import React, {useState} from 'react';
import {Layout, Menu, Upload, Button} from "antd";
import {FolderOpenOutlined, LoadingOutlined, UploadOutlined, FileImageOutlined, CloseOutlined} from "@ant-design/icons";
import {track} from "@amplitude/analytics-browser";
import {useTheme} from "./ThemeSwitching/use-theme";

const { Sider } = Layout;

const transformAssetsList = (assetsList, loaded) => {
    let result = [];

    let childs = [];
    if (!loaded) {
        childs = [
            {
                key: "loading_assets",
                icon: React.createElement(LoadingOutlined),
                label: "Loading"
            }
        ]
    } else {
        if (!assetsList.length) {
            childs = [
                {
                    key: "no_assets",
                    icon: React.createElement(CloseOutlined),
                    label: "No assets"
                }
            ]
        } else {
            childs = assetsList.map((asset, j) => {
                const subKey = j + 1;
                return {
                    key: subKey,
                    icon: React.createElement(FileImageOutlined),
                    label: asset.name
                };
            })
        }
    }

    result.push(
        {
            key: 'assets',
            icon: React.createElement(FolderOpenOutlined),
            label: 'Assets',
            children: childs
        }
    );

    return result;
}

const AssetsMenu = ({uploading, setUploading, loaded, assetsList, onSelectCallback, uploadProps, selectable}) => {
    const [uploadHidden, setUploadHidden] = useState(false);

    const [darkMode, setDarkMode] = useTheme();

    return (
        <Sider
            width={200}
            className="site-layout-background"
            style={{
                backgroundColor: darkMode ? "#1f1f1f" : "white",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px"
            }}
            collapsible
            onCollapse={(collapsed, type) => {
                setUploadHidden(collapsed);
            }}
        >
            <Upload {...uploadProps} >
                <Button
                    type="primary"
                    icon={<UploadOutlined />}
                    style={{margin: 16, borderRadius: 8}}
                    hidden={uploadHidden}
                    disabled={uploading}
                    loading={uploading}
                    onClick={() => {
                        track("upload_clicked");
                        setUploading(true);
                    }}
                >
                    Upload
                </Button>
            </Upload>
            <Menu
                mode="inline"
                style={{
                    height: '100vh',
                    borderRight: 0,
                }}
                selectable={selectable}
                items={transformAssetsList(assetsList, loaded)}
                onSelect={(item) => onSelectCallback({
                    ...item,
                    url: assetsList[item.key - 1].url,
                    name: assetsList[item.key - 1].name,
                    path: assetsList[item.key - 1].path
                })}
            />
        </Sider>
    );
};

export default AssetsMenu;